(function () {
  'use strict';

  if (window.advPersonalizationCartLoaded) return;
  window.advPersonalizationCartLoaded = true;

  var formIds = new Set([
    'add-item-form-product-custom-1line',
    'add-item-form-product-custom-1line-bar',
    'add-item-form-product-custom-1line-sportbar',
    'add-item-form-product-custom-1line-mancave',
    'add-item-form-product-custom-1line-gameroom',
    'add-item-form-product-custom-2line-name',
    'add-item-form-product-custom-teamnumber'
  ]);

  var submitting = new WeakSet();

  function isTargetGlobo(form) {
    return new FormData(form)
      .getAll('properties[_has_gpo]')
      .some(function (value) {
        return String(value).trim() === '1695364';
      });
  }

  function setHidden(form, name, value) {
    var field = Array.from(form.elements).find(function (item) {
      return item.name === name;
    });

    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }

    field.value = value;
  }

  function prepareFields(form) {
    var customization = form.querySelector(
      '#tee-customization-id'
    );

    if (customization) {
      setHidden(
        form,
        'properties[customization_id]',
        customization.value
      );
    }

    Array.from(form.elements).forEach(function (field) {
      var name = field.name || '';

      if (
        name.startsWith('properties[') &&
        (
          name === 'properties[Estimated delivery between]' ||
          name.includes('Original price')
        )
      ) {
        field.disabled = true;
      }
    });
  }

  function handle(event, form) {
    if (isTargetGlobo(form)) {
      prepareFields(form);

      // Disable the theme handler; let Globo handle submission.
      form.querySelectorAll(
        'input.add-to-cart[type="submit"], ' +
        'button.add-to-cart[type="submit"]'
      ).forEach(function (button) {
        button.onclick = null;
      });

      return;
    }

    // Preserve the existing custom-template behavior.
    if (!formIds.has(form.getAttribute('id'))) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (submitting.has(form)) return;
    if (!form.reportValidity()) return;

    prepareFields(form);

    var root = (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) || '/';

    setHidden(form, 'return_to', root + 'cart');
    submitting.add(form);

    HTMLFormElement.prototype.submit.call(form);
  }

  window.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var button = event.target.closest(
      'input.add-to-cart[type="submit"], ' +
      'button.add-to-cart[type="submit"]'
    );

    if (!button || button.disabled || !button.form) return;

    handle(event, button.form);
  }, true);

  window.addEventListener('submit', function (event) {
    var form = event.target;

    if (!(form instanceof HTMLFormElement)) return;

    if (
      event.submitter &&
      !event.submitter.classList.contains('add-to-cart')
    ) {
      return;
    }

    handle(event, form);
  }, true);

  window.addEventListener('pageshow', function () {
    submitting = new WeakSet();
  });
})();